"use strict";

exports.__esModule = true;
exports.RightEditPanel = RightEditPanel;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var RightEditPanelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "RightEditPanel__RightEditPanelWrapper",
  componentId: "sc-19wpav0-0"
})(["display:flex;flex:0 0 300px;color:", ";background:", ";align-items:flex-start;padding:0.5rem 1rem;justify-content:center;.", "{margin-top:50%;}"], (0, _Theme.val)("RightEditPanelTextColor"), (0, _Theme.val)("RightEditPanelBackground"), _core.Classes.SPINNER);

/**
 * Right aligned side panel
 */
function RightEditPanel(_ref) {
  var children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(RightEditPanelWrapper, extra, children);
}